<template>
    <!-- 菜单按钮 -->
    <transition
        name="custom-classes-transition"
        enter-active-class="animated slideInLeft"
        leave-active-class="animated slideOutLeft"
    >
        <div id="com-menu" v-if="menuOpen">
            <div
                :class="!menuOpen ? 'close' : ''"
                class="menu-bar--on flex_start flex_column"
            >
                <div class="menu-icon" @click="onMenu">
                    <img src="./images/list_menu.png" />
                </div>
                <div class="list">
                    <!-- 一级分类 -->
                    <details
                        v-for="(item, menuIndex) in menuList"
                        class="level-dad"
                        :key="menuIndex"
                        ref="level"
                    >
                        <!-- 标题 -->
                        <summary
                            class="level flex-cc"
                            @click="onLevel(menuList, menuIndex)"
                        >
                            <span>
                                {{ item.name }}
                            </span>
                            <span
                                class="level-icon iconfont icon-shanghua"
                                :class="item.state ? 'level-icon--on' : ''"
                            />
                        </summary>
                        <!-- 二级分类 -->
                        <details
                            v-for="(secondItem, index) in item.secondLevel"
                            :key="index"
                            :ref="`second${menuIndex}`"
                        >
                            <!-- 标题 -->
                            <summary
                                @click="
                                    onLevel(
                                        item.secondLevel,
                                        index,
                                        `second${menuIndex}`
                                    )
                                "
                                :class="
                                    secondItem.state ? 'second-level--on' : ''
                                "
                                class="second-level"
                            >
                                {{ secondItem.name }}
                            </summary>
                            <!-- 三级列表 -->
                            <!-- :class="threeItem.state ? 'threeLevel--on' : 'threeLevel--on'" -->
                            <p
                                class="threeLevel"
                                :class="
                                    threeItem.router === $route.name
                                        ? 'threeLevel--on'
                                        : ''
                                "
                                @click="onThree(threeItem)"
                                v-for="(threeItem,
                                index) in secondItem.threeLevel"
                                :key="index"
                            >
                                {{ threeItem.name }}
                            </p>
                        </details>
                    </details>
                </div>
                <!--  -->
                <div class="menu-home flex-cc" @click="onHome">
                    <img src="./images/list_index.png" alt="" />
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    name: "comMenu",
    components: {},
    props: {
        // 菜单展开状态
        menuOpen: {
            type: Boolean,
            default: () => {
                return false;
            }
        }
    },
    watch: {
        menuOpen(newVal, oldVal) {
            if (!newVal) {
                this.resetState();
            } else {
                this.getRouter(this.menuList);
            }
        }
    },
    data() {
        return {
            menuList: [
                {
                    id: 1,
                    name: "数据",
                    state: false,
                    secondLevel: [
                        {
                            id: 1,
                            name: "夏河县综合分析",
                            state: false,
                            threeLevel: [
                                {
                                    name: "综合分析",
                                    router: "provincial"
                                },
                            ]
                        },
                        {
                            id: 2,
                            name: "景区综合分析",
                            state: false,
                            threeLevel: [
                                {
                                    name: "综合分析",
                                    router: "spotDisplay"
                                },
                            ]
                        },
                        {
                            id: 3,
                            name: "今日票务分析",
                            state: false,
                            threeLevel: [
                                {
                                    name: "票务分析",
                                    router: "todayTicketAnalysis"
                                },
                            ]
                        },
                        {
                            id: 4,
                            name: "票务综合分析",
                            state: false,
                            threeLevel: [
                                {
                                    name: "综合分析",
                                    router: "ticketAnalysis"
                                },
                            ]
                        },
                        {
                            id: 5,
                            name: "夏河县游客画像",
                            state: false,
                            threeLevel: [
                                {
                                    name: "游客画像分析",
                                    router: "touristPortrait"
                                },
                            ]
                        },
                        {
                            id: 6,
                            name: "景区游客画像",
                            state: false,
                            threeLevel: [
                                {
                                    name: "游客画像分析",
                                    router: ""
                                },
                            ]
                        },
                        {
                            id: 7,
                            name: "数据综合对比",
                            state: false,
                            threeLevel: [
                                {
                                    name: "综合对比",
                                    router: ""
                                },
                            ]
                        },
                        {
                            id: 8,
                            name: "小程序使用情况",
                            state: false,
                            threeLevel: [
                                {
                                    name: "使用情况分析",
                                    router: ""
                                },
                            ]
                        },
                    ]
                }
            ],
            routerList: null
        };
    },
    computed: {},
    beforeMount() {},
    mounted() {},
    methods: {
        resetState() {
            // 重置list状态
            for (const i in this.menuList) {
                this.menuList[i].state = false;
                for (const a of this.menuList[i].secondLevel) {
                    a.state = false;
                }
            }
        },
        getRouter(e) {
            // 数据处理router和相关索引
            let list = e;
            let router = [];
            let routerIndex = [];
            for (const i in list) {
                if (list[i].secondLevel) {
                    for (const a in list[i].secondLevel) {
                        if (list[i].secondLevel[a].threeLevel) {
                            for (const b of list[i].secondLevel[a].threeLevel) {
                                if (b.router === this.$route.name) {
                                    routerIndex.push({ one: i, two: a });
                                    router.push(b.router);
                                    this.routerList = router;
                                    this.routerIndex = routerIndex;
                                    this.determineRouter(router, routerIndex);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        },
        determineRouter(e) {
            // 判断当前router是否存在menuList里
            if (
                e.some(item => {
                    return item === this.$route.name;
                })
            ) {
                this.openList();
            }
        },
        openList() {
            // 实现自动展开menuList关键代码
            if (this.$el.id === "com-menu") {
                let i = this.routerList.findIndex(item => {
                    return item === this.$route.name;
                });
                let index = this.routerIndex[i].one; // 一级菜单索引
                let refsName = `second${index}`; // 关键字加一级菜单索引
                let indexTwo = this.routerIndex[i].two; // 二级菜单索引
                // 打开一级菜单
                this.onLevel(this.menuList, index); // 传入总list和一级菜单索引
                this.$refs["level"][+index].open = true; // 传入一级菜单索引
                // 打开二级菜单
                this.onLevel(
                    this.menuList[+index].secondLevel,
                    indexTwo,
                    refsName
                ); // 一级菜单索引，二级菜单索引，关键字加一级菜单索引
                this.$refs[refsName][+indexTwo].open = true; // 关键字加一级菜单索引,二级菜单索引
            } else {
                setTimeout(() => {
                    this.openList();
                }, 4);
            }
        },
        onThree(e) {
            // 三级菜单
            let router = e.router;
            if (router === this.$route.name) {
                return false;
            }
            switch (router) {
                case "line":
                    this.$router.push({
                        name: router,
                        params: { activeMenu: e.params }
                    });
                    break;
                default:
                    this.$router.push(router);
                    break;
            }
            this.$emit("onThree", e);
        },
        onMenu() {
            // 菜单icon按钮
            this.$emit("onMenu", this.menuOpen);
        },
        onLevel(list, index, refName) {
            // 改变一级及二级菜单开关
            let state = [list, index, refName];
            localStorage.setItem("menuState", JSON.stringify(state));
            let keyName = refName || "level"; // 设置ref名称
            let clickState = list[index].state; // 获取json状态
            let levelRef = this.$refs[keyName]; // 获取dom实例
            let levelList = list; // 获取完成对应菜单全部json
            if (!clickState) {
                // 如果打开菜单关闭全部同级菜单
                for (let i in levelRef) {
                    levelRef[i].open = clickState;
                    levelList[i].state = clickState;
                }
            }
            // 关键代码
            levelList[index].state = !clickState;
            this.$emit("onLevel", list, index);
        },
        onHome() {
            // 首页icon按钮
            try {
                this.$router.push("portal");
            } catch (error) {}
            this.$emit("onHome");
        }
    }
};
</script>

<style lang="scss" scoped>
#com-menu {
    * {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
    }

    .open {
    }
    .close {
        animation: anim-close linear 0.25s;
    }
    .menu-bar--on {
        // cursor: pointer;
        position: fixed;
        top: vh(7);
        left: 0;
        z-index: 10000;
        padding: vh(137) vw(20) vw(15) vw(20);
        width: vw(255);
        height: 100vh;
        background: #081531;
        box-shadow: 0px 0px 31px 1px rgba(24, 157, 242, 0.25);
        animation: anim-open linear 0.25s;
        .level-icon {
            //   width: vw(13);
            //   height: vw(14);
            color: #19baff;
            font-size: vw(14);
            margin-left: vw(8);
            transform: rotateX(180deg); /* 垂直镜像翻转 */
            //   img {
            //     transform: rotateX(180deg); /* 垂直镜像翻转 */
            //   }
            &--on {
                transform: rotateX(0deg); /* 垂直镜像翻转 */
                // img {
                //   transform: rotateX(0deg); /* 垂直镜像翻转 */
                // }
            }
        }
        .list {
            width: 100%;
            height: 100%;

            overflow-y: scroll;
            position: relative;
            // animation: anim-open linear .5s;
            &::-webkit-scrollbar {
                display: none;
            }
            &:before {
                content: "";
                position: absolute;
                top: vh(-25);
                left: vw(46);
                height: 110%;
                width: vw(2);
                background: rgba(0, 180, 255, 0.28);
            }
        }

        .level-dad {
            padding-left: vw(9);
        }
        // details {
        .level-dad {
            summary {
                list-style: none;
                width: 100%;
            }
            .level {
                cursor: pointer;
                line-height: vh(34);
                background: linear-gradient(
                    88deg,
                    rgba(0, 180, 255, 0.01) 1%,
                    rgba(0, 180, 255, 0.56) 46%,
                    rgba(0, 180, 255, 0) 100%
                );
                border-bottom: vw(1) solid #00b4ff;
                font-size: vw(18);
                font-family: Source-Medium;
                font-weight: 500;
                color: #ffffff;
                margin-top: vh(20);
                position: relative;
                &:before {
                    content: "";
                    width: vw(16);
                    height: vw(16);
                    position: absolute;
                    left: vw(-19);
                    bottom: vw(-10);
                    background: #08193e;
                    border: vw(2) solid #00b4ff;
                    border-radius: 50%;
                }
                &:after {
                    content: "";
                    position: absolute;
                    left: vw(-13);
                    bottom: vw(-4);
                    width: vw(8);
                    height: vw(8);
                    background: #00b4ff;
                    border-radius: 50%;
                }
            }
            .second-level {
                cursor: pointer;
                padding-left: vw(32);
                margin-top: vh(36);
                // font
                font-size: vw(16);
                font-family: Source-Regular;
                font-weight: 400;
                color: #5a6a9e;
                text-align: left;
                position: relative;
                animation: second-up linear 0.4s;
                // animation: second-close linear 0.4s;
                &:before {
                    content: "";
                    position: absolute;
                    top: vh(12);
                    left: 0;
                    width: vw(28);
                    border-top: vw(1) dashed #00b4ff;
                }
                &--on {
                    color: #00b4ff;
                }
            }
            .threeLevel {
                cursor: pointer;
                padding-left: vw(35);
                margin-top: vh(20);
                // font
                text-align: left;
                font-size: vw(14);
                font-family: Source-Regular;
                font-weight: 400;
                color: #3c587e;
                position: relative;
                animation: three-up linear 0.4s;
                &:before {
                    content: "";
                    position: absolute;
                    left: vw(15);
                    top: vh(4);
                    z-index: 12;
                    width: vw(9);
                    height: vw(9);
                    background: #08193e;
                    border: vw(1) solid #00b4ff;
                    border-radius: 50%;
                }
                &:after {
                    content: "";
                    position: absolute;
                    left: vw(19.5);
                    top: vh(17);
                    width: vw(1);
                    height: vh(30);
                    background: #00b4ff;
                }
                &:last-child {
                    &:after {
                        display: none;
                    }
                }
                &--on {
                    cursor: default;
                    color: #b2e8ff;
                    &::before {
                        background: #00b4ff;
                    }
                }
                &:hover {
                    color: #b2e8ff;
                    &::before {
                        background: #00b4ff;
                    }
                }
            }
        }
        .list {
            padding-left: vw(47);
        }
        .menu-icon,
        .menu-home {
            $wh: 96;
            cursor: pointer;
            width: vw($wh);
            height: vw($wh);
            // position: absolute;
            //top: vh(7);
            //left: vw(64);
            z-index: 1;
            // 展开菜单
            img {
                width: 100%;
                height: auto;
                //   width: auto;
                //   height: 100%;
                margin-bottom: auto;
            }
        }
    }
}
// 总菜单动画
@keyframes anim-open {
    0% {
        transform: translate3d(vw(-255), 0, 0);
    }
    100% {
        transform: translate3d(0, 0, 0);
    }
}
@keyframes anim-close {
    0% {
        transform: translate3d(vw(-160), 0, 0);
    }
    100% {
        transform: translate3d(0, 0, 0);
    }
}
// 二级菜单动画
@keyframes second-up {
    0% {
        transform: translate3d(0, vh(-40), 0);
    }
    100% {
        transform: translate3d(0, 0, 0);
    }
}
@keyframes second-close {
    0% {
        transform: translate3d(0, 0, 0);
    }
    100% {
        transform: translate3d(0, vh(-40), 0);
    }
}
// 三级菜单动画
@keyframes three-up {
    0% {
        transform: translate3d(0, vh(-30), 0);
    }
    100% {
        transform: translate3d(0, 0, 0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/comMenu/comMenu.vue